import { atom } from 'recoil';
import { selectorUserInfo } from './selectors';

export const collapsedSider = atom({
  key: 'collapsedSiderUnique',
  default: false
});

export const atomUserInfo = atom({
  key: 'atomUserInfo',
  default: selectorUserInfo
});
